import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { GrCertificate } from "react-icons/gr";
import { FaTruck } from "react-icons/fa";
import { FaRegHandshake } from "react-icons/fa";
import { AiOutlineStar } from "react-icons/ai";
import profileImage from "../../assets/owner2.jpeg";
import { GiHighGrass } from "react-icons/gi";
import AOS from "aos";
import "aos/dist/aos.css";

const CocoCoirExporters = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div className="bg-gradient-to-br from-green-100 via-white to-teal-100 py-12 px-6 sm:px-12 lg:px-20">
      <Helmet>
        <title>Tirumala Cocopeat | Best Cocopeat Exporters & Suppliers in Andhra Pradesh, Anantapur</title>
        <meta
          name="og:title"
          content="Tirumala Cocopeat | Premium Coco Coir Exporters"
        />
        <meta
          name="og:description"
          content="Explore premium quality coco coir and cocopeat products from India's leading exporters, Tirumala Cocopeat. Trusted by global agricultural and horticulture industries."
        />
        <meta name="og:type" content="website" />
        <meta name="og:url" content="https://tirumalacocopeat.vercel.app" />
        <meta
          name="og:image"
          content="https://tirumalacocopeat.vercel.app/assets/preview-image.jpg"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Tirumala Cocopeat - Premium Coco Coir Exporters in India"
        />
        <meta
          name="twitter:description"
          content="Delivering high-quality coco peat solutions worldwide. Sustainable, innovative, and reliable coco coir products from India."
        />
      </Helmet>

      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-12" data-aos="fade-down">
          <div className="inline-flex items-center justify-center mb-4">
            <GiHighGrass className="w-12 h-12 text-green-600 mr-3 animate-bounce" />
            <h1 className="text-4xl font-bold text-green-700 drop-shadow-md">
              Coco Coir Exporters in India
            </h1>
          </div>
          <p className="text-gray-600 text-lg">
            Delivering premium quality coco peat solutions worldwide, blending
            tradition with innovation.
          </p>
        </div>

        {/* Content Section */}
        <div
          className="bg-white shadow-2xl rounded-3xl p-8 lg:flex lg:items-start lg:space-x-12"
          data-aos="fade-up"
        >
          {/* Profile Section */}
          <div className="flex-shrink-0 mb-8 lg:mb-0" data-aos="zoom-in">
            <div className="relative p-6 bg-gradient-to-br from-teal-50 to-green-50 rounded-xl shadow-lg hover:shadow-2xl transition-shadow">
              <img
                src={profileImage}
                alt="Founder"
                className="w-32 h-32 object-cover rounded-full mx-auto border-4 border-teal-500"
              />
              <div className="mt-6 text-center">
                <p className="text-lg font-bold text-green-700">Ramana</p>
                <p className="text-gray-500">Founder</p>
              </div>
            </div>
          </div>

          {/* Text Content */}
          <div className="flex-1">
            <p
              className="text-gray-700 leading-relaxed mb-8 text-lg"
              data-aos="fade-right"
            >
              <strong>Tirumala Cocopeat</strong> specializes in high-quality
              Coco Products, blending agricultural expertise with sustainable
              innovation. We offer customized solutions to meet the unique needs
              of our global clients. Experience unparalleled quality and service
              with our premium offerings.
            </p>

            {/* Feature List */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {/* Feature 1 */}
              <div
                className="flex items-center bg-gradient-to-r from-gray-50 to-teal-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
                data-aos="flip-right"
              >
                <GrCertificate className="w-10 h-10 text-green-600 mr-4" />
                <div>
                  <p className="text-lg font-medium text-gray-800">
                    Superior Product Quality
                  </p>
                  <p className="text-sm text-gray-500">
                    Certified and consistent excellence.
                  </p>
                </div>
              </div>

              {/* Feature 2 */}
              <div
                className="flex items-center bg-gradient-to-r from-gray-50 to-teal-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
                data-aos="flip-right"
              >
                <FaRegHandshake className="w-10 h-10 text-green-600 mr-4" />
                <div>
                  <p className="text-lg font-medium text-gray-800">
                    Competitive Pricing
                  </p>
                  <p className="text-sm text-gray-500">
                    Value for money guaranteed.
                  </p>
                </div>
              </div>

              {/* Feature 3 */}
              <div
                className="flex items-center bg-gradient-to-r from-gray-50 to-teal-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
                data-aos="fade-right"
              >
                <FaTruck className="w-10 h-10 text-green-600 mr-4" />
                <div>
                  <p className="text-lg font-medium text-gray-800">
                    On-time Delivery
                  </p>
                  <p className="text-sm text-gray-500">
                    Reliable global logistics.
                  </p>
                </div>
              </div>

              {/* Feature 4 */}
              <div
                className="flex items-center bg-gradient-to-r from-gray-50 to-teal-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
                data-aos="fade-right"
              >
                <AiOutlineStar className="w-10 h-10 text-green-600 mr-4" />
                <div>
                  <p className="text-lg font-medium text-gray-800">
                    100% Client Happiness
                  </p>
                  <p className="text-sm text-gray-500">
                    Our priority is your satisfaction.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CocoCoirExporters;
